import React from 'react';

import List from '@material-ui/core/List';
import SettingsCard from './SettingsCard';


const SettingsMenu = (props) => {

    return (
        <List>
            {props.cardList ? props.cardList.map(c => 
                <SettingsCard 
                    name={c.name} 
                    items={c.items} 
                    icon={c.icon} 
                    toogleStateAction={props.toogleStateAction}
                    key={c.name} 
                />
            ) : null}

        </List>
    );
}

export default SettingsMenu;